import React from 'react';

import { useApp } from '../../../store/AppContext';
import { barRadiusClass, LANE_H, laneTop } from './lanes';
import { previewIndexes } from './previewIndexes';
import ResizeHandle from './ResizeHandle';

/* Barre d'affectation : infobulle, clic pour modifier l'affectation du jour cliqué, poignées de
   redimensionnement (manager). */
export default function PlanningBar({ sg, match, color, label, hoverLines, roundedHandles }) {
  const {
    COL,
    days,
    isManager,
    openEditAssignment,
    setTimelineHover,
    appState,
    timelineDrag,
    timelineResize,
  } = useApp();
  const { sIdx, eIdx } = previewIndexes(sg, match, timelineResize, days);
  const truncLeft = sg.realStart < days[0].iso,
    truncRight = sg.realEnd > days[days.length - 1].iso;
  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onMouseEnter={(e) => setTimelineHover({ x: e.clientX, y: e.clientY, lines: hoverLines })}
      onMouseMove={(e) => setTimelineHover((h) => (h ? { ...h, x: e.clientX, y: e.clientY } : h))}
      onMouseLeave={() => setTimelineHover(null)}
      onClick={(e) => {
        e.stopPropagation();
        setTimelineHover(null);
        if (timelineDrag || timelineResize) return;
        const barLeft = e.currentTarget.getBoundingClientRect().left;
        const clickIdx = Math.max(
          sIdx,
          Math.min(eIdx, sIdx + Math.floor((e.clientX - barLeft) / COL)),
        );
        const iso = days[clickIdx].iso;
        const target =
          sg.affIds.find((id) => {
            const a = appState.affectations.find((x) => x.id === id);
            return a && a.debut <= iso && a.fin >= iso;
          }) || sg.affId;
        openEditAssignment(target, iso);
      }}
      className={`[grid-row:1] relative rounded-[6px] flex flex-col justify-center gap-[2px] py-[0] px-[8px] overflow-hidden shadow-[0_1px_2px_rgba(0,0,0,0.12)] ${barRadiusClass(truncLeft, truncRight)} ${isManager ? 'cursor-pointer' : 'cursor-default'}`}
      style={{
        gridColumn: `${sIdx + 1} / ${eIdx + 2}`,
        marginTop: laneTop(sg.lane),
        height: LANE_H,
        background: color,
      }}
    >
      <span className="text-[11px] font-semibold text-white whitespace-nowrap overflow-hidden [text-overflow:ellipsis] leading-[1.15]">
        {label}
      </span>
      <span className="text-[10px] font-semibold leading-[1] whitespace-nowrap text-[rgba(255,255,255,0.9)]">
        {sg.totalH}h
      </span>
      {isManager && (
        <ResizeHandle
          edge="left"
          affId={sg.leftAffId}
          match={match}
          dayIdx={sIdx}
          rounded={roundedHandles}
        />
      )}
      {isManager && (
        <ResizeHandle
          edge="right"
          affId={sg.rightAffId}
          match={match}
          dayIdx={eIdx}
          rounded={roundedHandles}
        />
      )}
    </div>
  );
}
